import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
// import PropTypes from "prop-types";
import styles from "./styles/ManageStudents.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { replaceErrorAvatar, showFailureToast } from "@helpers";
import clsx from "clsx";
import { formatNumberText } from "@helpers";
import { debounce } from "lodash";
import {
  Container,
  Dropdown,
  FormControl,
  InputGroup,
  Modal,
  Row,
  Stack,
} from "react-bootstrap";
import { getAllUsersAction } from "@redux/actions";
import {
  ADMIN_PAGESIZE_OPTIONS,
  APP_TITLE_SUFFIX,
  DEFAULT_PAGE_SIZE,
} from "@constants";
import { Paginator } from "@components/Paginator/Paginator";
import { TableCustom } from "@components/TableCustom/TableCustom";
import { EditModal } from "@pages/ManageUser/EditModal";

const ManageStudents = () => {
  // state
  const location = useLocation();
  const [pageSize, setPageSize] = useState(ADMIN_PAGESIZE_OPTIONS[1]);
  const [keyword, setKeyword] = useState("");
  const [target, setTarget] = useState(null);
  // const [currentRole, setCurrentRole] = useState(
  //   location.pathname.includes("admin-manage-students")
  //     ? "student"
  //     : location.pathname.includes("admin-manage-instructors")
  //     ? "instructor"
  //     : ""
  // );
  const [editModalVisible, setEditModalVisible] = useState(false);

  // variables
  let pagination = null;
  let resultSummary = "";

  // logics before hooks

  // hooks
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { allUsers } = useSelector((state) => state.user);

  // logics

  const handleCloseEditModal = () => setEditModalVisible(false);

  const editUser = (id) => {
    const target = allUsers.data?.find((one) => one.id === id);
    if (!target) {
      showFailureToast("Something'wrong, user not found!");
    } else {
      setTarget(target);
      setEditModalVisible(true);
    }
  };

  const columns = [
    {
      title: "Avatar",
      dataIndex: "avatarUrl",
      render: (url) => {
        return (
          <img
            src={url}
            alt={"user avatar"}
            style={{ width: "50px", height: "50px" }}
            onError={replaceErrorAvatar}
          />
        );
      },
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Balance",
      dataIndex: "balance",
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (role) => {
        return (
          <strong className={"text-success text-capitalize"}>{role}</strong>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (isActive) => {
        return (
          <strong
            className={clsx("text-capitalize", {
              ["text-success"]: isActive,
              ["text-danger"]: !isActive,
            })}
          >
            {isActive ? "Active" : "Block"}
          </strong>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id) => (
        <div>
          <i
            className={clsx("bi bi-pencil-square", styles.icon)}
            onClick={() => {
              editUser(id);
            }}
          />
        </div>
      ),
    },
  ];

  if (allUsers.pagination) {
    const { CurrentPage, PageSize, TotalCount } = allUsers.pagination;
    const start = (CurrentPage - 1) * PageSize + 1;
    const end = CurrentPage * PageSize;
    resultSummary = TotalCount
      ? `Showing ${start} to ${
          end < TotalCount ? end : TotalCount
        } of total ${formatNumberText(TotalCount, "user")}`
      : "No Result";
    pagination = <Paginator data={{ ...allUsers.pagination }} />;
  }
  const search = useCallback(
    debounce((Keyword) => {
      if (
        !Keyword ||
        Keyword.replace(/[^\w\s']|_/g, "")
          .replace(/\s+/g, " ")
          .trim()
      ) {
        searchParams.set("Keyword", Keyword);
        searchParams.set("PageNumber", 1);
        searchParams.sort();
        setSearchParams(searchParams, { replace: true });
      }
    }, 500),
    []
  );

  const handlePageSizeChange = (option) => {
    setPageSize(option);
    searchParams.set("PageSize", option.value);
    searchParams.set("PageNumber", 1);
    searchParams.sort();
    setSearchParams(searchParams, { replace: true });
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
    search(event.target.value);
  };

  // UI partials

  const searchBox = (
    <InputGroup>
      <InputGroup.Text className={styles.searchBoxPrefix}>
        <i className="bi bi-search" />
      </InputGroup.Text>
      <FormControl
        type="search"
        placeholder="Search"
        value={keyword}
        onChange={handleKeywordChange}
      />
    </InputGroup>
  );

  // effects

  // useEffect(() => {
  //   if (location.pathname.includes("admin-manage-students")) {
  //     setCurrentRole("student");
  //   } else if (location.pathname.includes("admin-manage-instructors")) {
  //     setCurrentRole("instructor");
  //   }
  //   setPageSize(ADMIN_PAGESIZE_OPTIONS[1]);
  //   setKeyword("");
  //   setTarget(null);
  //   // searchParams.set("PageSize", DEFAULT_PAGE_SIZE);
  //   // searchParams.set("PageNumber", 1);
  //   // searchParams.set("Keyword", "");

  //   setSearchParams(searchParams, { replace: true });
  //   console.log("effect", location.pathname);
  // }, [location.pathname]);

  useEffect(() => {
    const Keyword = (searchParams.get("Keyword") || "")
      .replace(/[^\w\s']|_/g, "")
      .replace(/\s+/g, " ")
      .trim();
    const PageSize = Number(searchParams.get("PageSize")) || DEFAULT_PAGE_SIZE;
    const PageNumber = Number(searchParams.get("PageNumber")) || 1;

    dispatch(
      getAllUsersAction({
        Role: "student",
        Keyword,
        Orderby: "createdAt desc",
        PageSize,
        PageNumber,
      })
    );
  }, [dispatch, searchParams]);

  useLayoutEffect(() => {
    const Keyword = searchParams.get("Keyword") || "";
    document.title = location.pathname.includes("admin-manage-students")
      ? `Manage Students | ${APP_TITLE_SUFFIX}`
      : location.pathname.includes("admin-manage-instructors")
      ? `Manage Instructors | ${APP_TITLE_SUFFIX}`
      : "";
    const pageSize = ADMIN_PAGESIZE_OPTIONS.find(
      (one) =>
        one.value ===
        (Number(searchParams.get("PageSize")) ||
          ADMIN_PAGESIZE_OPTIONS[1].value)
    );
    setKeyword(Keyword);
    setPageSize(pageSize);
  }, [location.pathname]);

  // useEffect(() => {

  // }, [currentRole])

  // render
  return (
    <Container fluid>
      <Stack direction="horizontal" className="h5 my-4">
        <div className={clsx(styles.headerContainer)}>
          <i className="bi bi-mortarboard" /> <span>Manage Students</span>
        </div>
      </Stack>
      {searchBox}
      <div className="d-flex justify-content-between align-items-center py-3">
        <Dropdown>
          <Dropdown.Toggle
            id="sortPopover"
            variant="light"
            className="border"
            disabled={allUsers.processing}
          >
            Show <strong>{pageSize.label}</strong>
          </Dropdown.Toggle>
          <Dropdown.Menu variant="light" className="w-100">
            {ADMIN_PAGESIZE_OPTIONS.map((option) => (
              <Dropdown.Item
                className={clsx(
                  styles.option,
                  pageSize.value === option.value ? styles.active : ""
                )}
                key={option.id}
                active={pageSize.value === option.value}
                onClick={() => handlePageSizeChange(option)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <strong>{resultSummary}</strong>
      </div>
      <Row>
        <TableCustom
          indexing
          columns={columns}
          dataSource={allUsers.data ?? []}
          isLoading={allUsers.processing}
        />
      </Row>
      <div className="d-flex justify-content-center">{pagination}</div>;
      <Modal show={editModalVisible} onHide={handleCloseEditModal}>
        <EditModal data={target} handleClose={handleCloseEditModal} />
      </Modal>
    </Container>
  );
};

/* required: display name */
ManageStudents.displayName = "ManageStudents";

/* required: props types */
ManageStudents.propTypes = {};

/* required: default props */
ManageStudents.defaultProps = {};

export { ManageStudents };
